
































import {Component, Vue} from 'vue-property-decorator';
import {Item} from '@/models/PlanModel';
import {mapGetters} from 'vuex';
import PlanBodyActions from '@/views/journals/plan/PlanBodyActions.vue';
import CSimpleTable from '@/components/base/table/CSimpleTable.vue';

@Component({
    components: {
        CSimpleTable,
        PlanBodyActions,
    },
    computed: {
        ...mapGetters('plan', ['items']),
    },
})
export default class PlanBody extends Vue {
    public items!: Array<Item> | undefined;
}
